import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export const PageMetaData = ({ seo }) => {
  const { lang } = useParams();

  if (!seo || !seo.title || !seo.description) {
    return null;
  }

  const currentTitle = seo.title[lang];
  const currentDesc = seo.description[lang];

  if (!currentTitle) return null;

  return (
    <Helmet>
      <title>{currentTitle}</title>
      <meta name="description" content={currentDesc} />
      <meta property="og:title" content={currentTitle} />
      <meta property="og:description" content={currentDesc} />
    </Helmet>
  );
};
